import { useAuth } from "../../lib/auth";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="eyebrow">Checking access…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-6 text-center">
        <div>
          <div className="eyebrow" style={{ color: "#D4AF37" }}>Restricted</div>
          <div className="font-display text-3xl text-[#0B1F3A] mt-3">This area requires elevated access.</div>
          <div className="mt-3 text-sm text-[#5F6B7A]">Contact your account manager for role adjustment.</div>
        </div>
      </div>
    );
  }
  return children;
}
